export const SET_DASHBOARD_DATA = 'SET_DASHBOARD_DATA'
export const SET_SHOP_WAIT_TIME = 'SET_SHOP_WAIT_TIME';
export const SET_SHOP_STATUS = 'SET_SHOP_STATUS';
export const SET_SHOP_TYPE = 'SET_SHOP_TYPE';